import { IApp03SubTask } from '../types';
import { EntityService } from './EntityService';

export class App03SubTaskService extends EntityService<IApp03SubTask> {
    protected childrenEntities = [];
    constructor() {
        super(`/App03SubTasks`);
    }

    public readSubTasksForList(app03TaskID: number): Promise<IApp03SubTask[]> {
        return this.readAll(
            `?$filter=App03TaskID eq ${app03TaskID}`
            + `&$expand=AssignedToUser($select=ID,Title),`
        );
    }
}